var VIDEO_TYPE = 'wix-draft-plugin-video';
var VIDEO_TYPE_LEGACY = 'VIDEO-EMBED';
export { VIDEO_TYPE_LEGACY, VIDEO_TYPE };
//# sourceMappingURL=types.js.map